const PlusMinus01Icon = /*#__PURE__*/ [
  ["path", { d: "M12 3V17M19 10H5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 21H5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { PlusMinus01Icon as default };
//# sourceMappingURL=PlusMinus01Icon.js.map
